/** Minimal shape for batch import via serializedItemsJson */
export type InboundSerialItem = { serialNumber: string; status?: string };

export function serialsFromJson(json?: string | null): string[] {
    if (!json?.trim()) return [];
    try {
        const parsed = JSON.parse(json) as unknown;
        if (!Array.isArray(parsed)) return [];
        return parsed
            .map((item) => {
                if (typeof item === 'string') return item.trim();
                if (item && typeof item === 'object' && 'serialNumber' in item) {
                    return String((item as InboundSerialItem).serialNumber || '').trim();
                }
                return '';
            })
            .filter((s) => s.length > 0);
    } catch {
        return [];
    }
}

export function serialsToJson(serials: string[]): string | undefined {
    const cleaned = serials.map((s) => s.trim()).filter((s) => s.length > 0);
    if (cleaned.length === 0) return undefined;
    const items: InboundSerialItem[] = cleaned.map((serialNumber) => ({
        serialNumber,
        status: 'AVAILABLE',
    }));
    return JSON.stringify(items);
}

export function serialsFromPreview(previewJson?: string | null): string[] {
    if (!previewJson?.trim()) return [];
    try {
        const preview = JSON.parse(previewJson) as { serialNumbers?: unknown };
        if (!Array.isArray(preview.serialNumbers)) return [];
        return preview.serialNumbers.map((s) => String(s).trim()).filter((s) => s.length > 0);
    } catch {
        return [];
    }
}
